import React from "react";
import CustomTable from "../../components/Custom/CustomTable";
import { CustomLabel } from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";

const ListView = ({ data }) => {
  const { t } = useTranslation();
  const modifiedData = data.map((item) => ({
    full_name: item.fpo_user.full_name,
    email: item.fpo_user.user.email,
    id: item.fpo_user.id,
    farmers: item.farmers.length,
  }));

  const tableTitles = [t("FPO Name"), t("Email"), t("Farmers")];
  const tableKeys = ["full_name", "email", "farmers"];
  return (
    <div>
      {modifiedData.length === 0 ? (
        <div
          style={{ justifyContent: "center", margin: "auto", display: "flex" }}
        >
          <CustomLabel>{t("No Data Found")}</CustomLabel>
        </div>
      ) : (
        <CustomTable
          data={modifiedData}
          titles={tableTitles}
          keys={tableKeys}
          t={t}
        />
      )}
    </div>
  );
};

export default ListView;
